<template>
  <div class="topo">

    <div class="topo-node topo-node--bus" :style="{ width: busWidth + 'px' }"></div>

    <div :key="node.uuid" class="topo-node" v-for="node in nodes"
      :style="{ transform: `translate(${node.position.x}px, ${node.position.y}px)` }">
      <div class="topo-node__content">
        <img :src="getImgSrcByName('eBlock')" alt="" width="40">
        <el-tooltip placement="top" effect="dark">
          <div :data-uuid="node.uuid"> {{ node.name }}</div>
          <template #content>
            <div>uuid: {{ node.uuid }}</div>
            <div>productModel: {{ node.productModel }}</div>
          </template>
        </el-tooltip>
      </div>
      <div class="topo-node__data">
        <div class="topo-node__item">
          <div class="topo-node__label">状态:</div>
          <div class="topo-node__value">{{ EBlockWorkState[node._readData.state_eblock] || "--" }}</div>
        </div>
        <div class="topo-node__item is-soc">
          <div class="topo-node__label">SOC:</div>
          <div class="topo-node__value">{{ node._readData.soc }}%</div>
        </div>
        <div class="topo-node__item">
          <div class="topo-node__label">功率:</div>
          <div class="topo-node__value">{{ node._readData.p_dc }}kW</div>
        </div>
        <div class="topo-node__item">
          <div class="topo-node__label">电流:</div>
          <div class="topo-node__value">{{ node._readData.i_dc }}A</div>
        </div>
        <div class="topo-node__item">
          <div class="topo-node__label">电压:</div>
          <div class="topo-node__value">{{ node._readData.u_dc }}V</div>
        </div>
      </div>
    </div>

    <div v-for="(line, index) in xLines" :key="index" class="topo-xline"
      :style="{ transform: `translate(${line.x0}px, ${line.y0}px)`, height: `${line.h}px` }">
    </div>
    <div v-for="(node, index) in nodes" :key="index" class="topo-yline"
      :style="{ transform: `translate(${node.line.x}px, ${node.line.y}px)` }">
    </div>
  </div>
</template>


<script setup>
import { computed, ref } from "vue";
import { getImgSrcByName } from "@/topo/core/utils/img-load";

const startX = 100;
const startY = 60;

// 5列5行
const column_count = 5;
const row_count = 5;

const busWidth = ref(0);

const props = defineProps({
  dialogData: {
    type: Object, default: () => { }
  }
});

busWidth.value = (() => {
  return column_count * 240;
})();

// 所有eBlock
// const EBLOCK_COUNT = 29;

const EBlockWorkState = {
  0x00: "空状态", 0x01: "停机", 0x02: "待机", 0x03: "充电", 0x04: "放电", 0x05: "降额", 0x06: "告警", 0x07: "故障"
};

const nodes = computed(() => {
  const ebList = props.dialogData?.childrenDataList ?? [];
  // const eBlockCount = ebList.length;

  const result = [];
  for (let i = 0; i < ebList.length; i++) {
    const eb = ebList[i];
    const columnIndex = Math.floor(i / column_count);
    const rowIndex = i % row_count;
    const x = startX + columnIndex * 200;
    const y = startY + rowIndex * 100;

    result.push({
      ...eb,
      _readData: eb._readData ?? {},
      uuid: eb.uuid,
      name: eb.sort + "#" + eb.eBlockName,
      columnIndex: columnIndex,
      rowIndex: rowIndex,
      position: {
        x: x, y: y
      },
      line: {
        x: x - 40, y: y + 40
      }
    });
  }

  return result;

});

//竖线

const xLines = computed(() => {
  const eBlockCount = props.dialogData?.childrenDataList?.length ?? 0;
  // 每根竖线高度为94px
  const LINE_COUNT = Math.ceil(eBlockCount / column_count);
  const LINE_HEIGHT = 94;

  return Array.from({ length: LINE_COUNT }, (_, i) => {
    const x = i * 200 + 60;
    let h = LINE_HEIGHT * row_count;

    if (i === LINE_COUNT - 1) {
      const len = eBlockCount - (LINE_COUNT - 1) * row_count;
      console.log("len", len);
      h = len > 0 ? len * LINE_HEIGHT : 0;
      // h = (EBLOCK_COUNT - column_count * row_count) * LINE_HEIGHT
    }

    const line = {
      x0: x, y0: 0, x1: x, y1: h, h: h
    };

    return line;
  });
});


</script>


<style scoped lang="scss">
.topo {
  height: 100%;
  position: relative;
  user-select: none;
  overflow: auto;
  padding: 12px;
}

.topo-node {
  display: flex;
  align-items: flex-start;
  font-size: 12px;
  position: absolute;
  z-index: 2;
  color: #1f2937;

  &--bus {
    position: absolute;
    background: linear-gradient(90deg, #2b57ee 0%, #5b7dfb 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 10px;
    left: 20px;
    right: 20px;
    top: 20px;
    border-radius: 5px;
    box-shadow: 0 1px 4px rgba(43, 87, 238, 0.28);
  }
}

.topo-node__content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 6px 8px;
  background: #ffffff;
  border: 1px solid #e9efff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
  min-width: 72px;

  >div {
    margin-top: 4px;
    font-weight: 600;
    color: #1f2937;
  }
}

.topo-node__data {
  display: flex;
  flex-direction: column;
  // margin-top: 8px;
  margin-left: 12px;
  padding: 4px 10px;
  background: #f5f7fb;
  border: 1px solid #e9efff;
  border-radius: 6px;
  gap: 0;
}

.topo-node__item {
  display: flex;
  align-items: center;
  line-height: 1.3;

  &.is-soc {
    color: #36c070;
    font-weight: 600;
  }
}

.topo-node__label {
  margin-right: 6px;
  color: #9aa0b5;
}

.topo-node__value {
  color: inherit;
}

.topo-xline {
  position: absolute;
  width: 1px;
  height: 470px;
  background: rgba(43, 87, 238, 0.55);
  top: 30px;
  z-index: 1;
}

.topo-yline {
  position: absolute;
  width: 46px;
  height: 1px;
  background: rgba(43, 87, 238, 0.55);
  z-index: 1;
}
</style>
